/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SaveClassModuleRecurrenceViewModel } from "../types/SaveClassModuleRecurrenceViewModel.ts";
import { eClassModuleRecurrenceTypeSchema } from "./eClassModuleRecurrenceTypeSchema.ts";

export const saveClassModuleRecurrenceViewModelSchema = z.object({
  type: z.optional(
    z
      .lazy(() => eClassModuleRecurrenceTypeSchema)
      .describe("1 = Weekly | 2 = Monthly | "),
  ),
  interval: z.optional(z.number().int()),
  weekDay: z.number().int().nullish(),
  monthDay: z.number().int().nullish(),
  startTime: z.string().nullish(),
  endTime: z.string().nullish(),
}) as unknown as ToZod<SaveClassModuleRecurrenceViewModel>;
